import { Component } from '@angular/core';

@Component({
  selector: 'app-inventory-aging-detail',
  standalone: false,
  
  templateUrl: './inventory-aging-detail.component.html',
  styles: ``
})
export class InventoryAgingDetailComponent {

}
